(() => {
const $32d680c4beb6f31d$var$selectors = {
    wrapper: '.mcfly-options',
    option: 'li.option'
};
const $32d680c4beb6f31d$var$classNames = {
    selected: 'selected'
};
const $32d680c4beb6f31d$var$elements = document.querySelectorAll($32d680c4beb6f31d$var$selectors.wrapper);
$32d680c4beb6f31d$var$elements.forEach((el)=>{
    const updateValue = ()=>{
        const activeOption = el.querySelector(`${$32d680c4beb6f31d$var$selectors.option}.${$32d680c4beb6f31d$var$classNames.selected}`);
        const value = activeOption ? activeOption.getAttribute('data-value') : '';
        el.setAttribute('data-value', value);
        // Create and dispatch the custom event
        const event = new CustomEvent('selectedOption', {
            detail: {
                value: value
            }
        });
        document.dispatchEvent(event);
    };
    // Check for active option.
    updateValue();
    // Add event listeners.
    const options = el.querySelectorAll($32d680c4beb6f31d$var$selectors.option);
    options.forEach((opt)=>{
        opt.addEventListener('click', ()=>{
            if (!opt.classList.contains($32d680c4beb6f31d$var$classNames.selected)) {
                // Remove selected class from all elements.
                options.forEach((opt)=>{
                    opt.classList.remove($32d680c4beb6f31d$var$classNames.selected);
                });
                // Add selected class to target element.
                opt.classList.add($32d680c4beb6f31d$var$classNames.selected);
                // Update active item.
                updateValue();
            }
        });
    });
});

})();
//# sourceMappingURL=options.min.js.map
